export const TRAILS = [
    {
        to: "Schronisko PTTK Hala Szrenicka (1195 m)",
        entries: [
            {
                name: "z Przełęczy Szklarskiej (886 m)",
                score: 10
            },
            {
                name: "Przełęcz Szklarska (886 m) - przejście graniczne Jakuszyce",
                score: 1
            },
            {
                name: "z Wodospadu Kamieńczyk",
                score: 6
            },
            {
                name: "z Przełęczy Mokrej (940 m)",
                score: 2
            },
            {
                name: "z Końskich Łbów",
                score: 1
            },

        ],
        descending: [
            {
                name: "z Przełęczy Szklarskiej (886 m)",
                score: 7
            },
            {
                name: "Przełęcz Szklarska (886 m) - przejście graniczne Jakuszyce",
                score: 1
            },
            {
                name: "z Wodospadu Kamieńczyk",
                score: 2
            },
            {
                name: "z Przełęczy Mokrej (940 m)",
                score: 3
            },
            {
                name: "z Końskich Łbów",
                score: 2
            },
        ]
    },
    {
        to: "Szrenica (1362 m)",
        entries: [
            {
                name: "ze Schroniska PTTK Hala Szrenicka (1195 m)",
                score: 3
            },
            {
                name: "z Końskich Łbów",
                score: 2
            },
            {
                name: "z Przełęczy Mokrej (940 m)",
                score: 2
            }
        ],
        descending: [
            {
                name: "ze Schroniska PTTK Hala Szrenicka (1195 m)",
                score: 1
            },
            {
                name: "z Końskich Łbów",
                score: 1
            },
            {
                name: "z Przełęczy Mokrej (940 m)",
                score: 1
            }
        ]
    },
    {
        to: "Przełęcz Mokra (940 m)",
        entries: [
            {
                name: "ze Schroniska PTTK Hala Szrenicka (1195 m)",
                score: 3
            },
            {
                name: "z Końskich Łbów",
                score: 1
            },
            {
                name: "z Czarciej Ambony (Śnieżne Kotły)",
                score: 3
            },
            {
                name: "ze Schroniska PTTK Hala pod Łabskim Szczytem (1168 m)",
                score: 3
            }
        ],
        descending: [
            {
                name: "ze Schroniska PTTK Hala Szrenicka (1195 m)",
                score: 2
            },
            {
                name: "z Końskich Łbów",
                score: 1
            },
            {
                name: "z Czarciej Ambony (Śnieżne Kotły)",
                score: 2
            },
            {
                name: "ze Schroniska PTTK Hala pod Łabskim Szczytem (1168 m)",
                score: 5
            }
        ]
    },
    {
        to: "Wysoki Most",
        entries: [
            {
                name: "z Wodospadu Kamieńczyk",
                score: 1
            },
            {
                name: "ze Szklarskiej Poręby-Huty",
                score: 2
            },
            {
                name: "ze Szklarskiej Poręby-Górnej",
                score: 4
            },
            {
                name: "ze Szklarskiej Poręby-Górnej przez Marysin",
                score: 5
            }
        ],
        descending: [
            {
                name: "z Wodospadu Kamieńczyk",
                score: 2
            },
            {
                name: "ze Szklarskiej Poręby-Huty",
                score: 1
            },
            {
                name: "ze Szklarskiej Poręby-Górnej",
                score: 2
            },
            {
                name: "ze Szklarskiej Poręby-Górnej przez Marysin",
                score: 3
            }
        ]
    },
    {
        to: "Schronisko PTTK Hala pod Łabskim Szczytem (1168 m)",
        entries: [
            {
                name: "z Wysokiego Mostu",
                score: 9
            },
            {
                name: "ze Szklarskiej Poręby-Górnej",
                score: 11
            },
            {
                name: "ze Schroniska PTTK Kochanówka Wodospad Szklarki",
                score: 11
            },
            {
                name: "z Trzech Jaworów (676 m)",
                score: 10
            },
            {
                name: "z rozdroża pod Wielkim Szyszakiem",
                score: 5
            }
        ],
        descending: [
            {
                name: "z Wysokiego Mostu",
                score: 5
            },
            {
                name: "ze Szklarskiej Poręby-Górnej",
                score: 6
            },
            {
                name: "ze Schroniska PTTK Kochanówka Wodospad Szklarki",
                score: 5
            },
            {
                name: "z Trzech Jaworów (676 m)",
                score: 5
            },
            {
                name: "z rozdroża pod Wielkim Szyszakiem",
                score: 5
            }
        ]
    },
    {
        to: "Czarcia Ambona (1490 m) (Śnieżne Kotły)",
        entries: [
            {
                name: "ze Schroniska PTTK Hala pod Łabskim Szczytem (1168 m)",
                score: 5
            },
            {
                name: "z Przełęczy pod Śmielcem (1390 m)",
                score: 2
            },
        ],
        descending: [
            {
                name: "ze Schroniska PTTK Hala pod Łabskim Szczytem (1168 m)",
                score: 2
            },
            {
                name: "z Przełęczy pod Śmielcem (1390 m)",
                score: 1
            },
        ]
    },
    {
        to: "Przełęcz pod Śmielcem (1390 m)",
        entries: [
            {
                name: "z rozdroża pod Wielkim Szyszakiem",
                score: 2
            },
            {
                name: "z Czarnej Przełęczy (1348 m)",
                score: 1
            },
        ],
        descending: [
            {
                name: "z rozdroża pod Wielkim Szyszakiem",
                score: 1
            },
            {
                name: "z Czarnej Przełęczy (1348 m)",
                score: 1
            },
        ]
    },
    {
        to: "Trzy Jawory (676 m)",
        entries: [
            {
                name: "z rozdroża pod Wielkim Szyszakiem",
                score: 4
            },
            {
                name: "z Jagniątkowa-pd",
                score: 4
            },
            {
                name: "ze Szklarskiej Poręby-Górnej",
                score: 6
            },
            {
                name: "ze Schroniska PTTK Kochanówka Wodospad Szklarki (510 m)",
                score: 5
            },
            {
                name: "z Michałowic",
                score: 2
            }
        ],
        descending: [
            {
                name: "z rozdroża pod Wielkim Szyszakiem",
                score: 9
            },
            {
                name: "z Jagniątkowa-pd",
                score: 3
            },
            {
                name: "ze Szklarskiej Poręby-Górnej",
                score: 6
            },
            {
                name: "ze Schroniska PTTK Kochanówka Wodospad Szklarki (510 m)",
                score: 3
            },
            {
                name: "z Michałowic",
                score: 2
            }
        ]
    },
    {
        to: "Schronisko PTTK Kochanówka Wodospad Szklarki (510 m)",
        entries: [
            {
                name: "ze Szklarskiej Poręby-Górnej",
                score: 4
            },
            {
                name: "ze Szklarskiej Poręby-Dolnej",
                score: 2
            },
            {
                name: "z Piechowic",
                score: 6
            },
        ],
        descending: [
            {
                name: "ze Szklarskiej Poręby-Górnej",
                score: 5
            },
            {
                name: "ze Szklarskiej Poręby-Dolnej",
                score: 3
            },
            {
                name: "z Piechowic",
                score: 5
            },
        ]
    },
    {
        to: "Michałowice",
        entries: [
            {
                name: "ze Schroniska PTTK Kochanówka Wodospad Szklarki (510 m)",
                score: 5
            },
            {
                name: "z Piechowic",
                score: 6
            },
        ],
        descending: [
            {
                name: "ze Schroniska PTTK Kochanówka Wodospad Szklarki (510 m)",
                score: 3
            },
            {
                name: "z Piechowic",
                score: 3
            },
        ]
    },

]